(function () {
  'use strict';

  if (customElements.get('product-card-carousel')) return;

  class ProductCardCarousel extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.setAttribute('role', 'region');
      this.setAttribute('aria-roledescription', 'carousel');
      if (!this.getAttribute('aria-label')) {
        this.setAttribute('aria-label', 'Galerie de visuels produit');
      }

      // aspect-ratio sur un custom element est peu fiable sur iOS Safari —
      // on convertit en padding-bottom (technique éprouvée du thème original).
      var aspectRatio = parseFloat(this.style.aspectRatio);
      if (aspectRatio) {
        this.style.height = '0';
        this.style.paddingBottom = (100 / aspectRatio).toFixed(4) + '%';
        this.style.aspectRatio = '';
      }

      var track      = this.querySelector('.product-carousel-track');
      var realSlides = Array.from(this.querySelectorAll('.product-carousel-slide'));
      if (!track || realSlides.length <= 1) return;

      var dotsDesktop    = this.dataset.dotsDesktop    !== 'false';
      var dotsDesktopPos = this.dataset.dotsDesktopPos || 'on-image';
      var dotsDesktopVis = this.dataset.dotsDesktopVis || 'hover';
      var dotsMobile     = this.dataset.dotsMobile     !== 'false';
      var dotsMobilePos  = this.dataset.dotsMobilePos  || 'on-image';
      var hasSizeOptions = this.dataset.sizeOptions     === 'true';
      var enableLoop     = this.dataset.loop            !== 'false';
      var realCount    = realSlides.length;
      var currentIndex = 0;
      var bars         = [];

      var figure  = this.closest('.product-featured-image--carousel');
      var prevBtn = this.querySelector('.flickity-prev');
      var nextBtn = this.querySelector('.flickity-next');

      function jumpTo(pos) {
        track.scrollLeft = pos;
      }

      // clientWidth est arrondi à l'entier (spec CSSOM). Dans une grille aux
      // largeurs fractionnaires (ex. 386.66px), l'écart se cumule à chaque
      // slide et finit par laisser apparaître une bande de l'image suivante.
      // getBoundingClientRect() conserve la précision sous-pixel.
      function trackWidth() {
        return track.getBoundingClientRect().width;
      }

      function loadImages(slideEl) {
        if (!slideEl) return;
        var trackWidth = track.offsetWidth || 400;
        slideEl.querySelectorAll('img').forEach(function (img) {
          var alreadyLoaded = img.classList.contains('lazyloaded');
          var hasPending    = img.dataset.carouselSrc || img.dataset.carouselSrcset || img.dataset.srcset;
          if (alreadyLoaded && !hasPending) return;
          img.sizes = trackWidth + 'px';
          if (img.dataset.sizes) img.removeAttribute('data-sizes');
          var src    = img.dataset.carouselSrc    || img.dataset.src;
          var srcset = img.dataset.carouselSrcset || img.dataset.srcset;
          if (src) {
            img.src = src;
            img.removeAttribute('data-carousel-src');
            img.removeAttribute('data-src');
          }
          if (srcset) {
            img.setAttribute('srcset', srcset);
            img.removeAttribute('data-carousel-srcset');
            img.removeAttribute('data-srcset');
          }
          img.classList.remove('lazyload', 'lazyloading', 'lazyautosizes');
          img.classList.add('lazyloaded');
        });
      }

      function preload(index) {
        loadImages(realSlides[index]);
        var prev = enableLoop ? (index - 1 + realCount) % realCount : index - 1;
        var next = enableLoop ? (index + 1) % realCount             : index + 1;
        if (prev >= 0 && prev < realCount) loadImages(realSlides[prev]);
        if (next >= 0 && next < realCount) loadImages(realSlides[next]);
      }

      var lastClone, firstClone;
      if (enableLoop) {
        lastClone  = realSlides[realCount - 1].cloneNode(true);
        firstClone = realSlides[0].cloneNode(true);
        lastClone.setAttribute('aria-hidden', 'true');
        lastClone.setAttribute('inert', '');
        firstClone.setAttribute('aria-hidden', 'true');
        firstClone.setAttribute('inert', '');
        track.insertBefore(lastClone, realSlides[0]);
        track.appendChild(firstClone);
      }

      requestAnimationFrame(function () {
        if (enableLoop) jumpTo(trackWidth());
        loadImages(realSlides[0]);
        self.dataset.currentIndex = '0';
      });

      var activated = false;
      function onFirstActivation() {
        if (activated) return;
        activated = true;
        if (!bpDesktop.matches) {
          realSlides.forEach(function(slide) { loadImages(slide); });
        } else {
          preload(currentIndex);
        }
        if (enableLoop) {
          loadImages(lastClone);
          loadImages(firstClone);
        }
      }

      var cardEl = this.closest('.product-card') || this;
      cardEl.addEventListener('mouseenter', onFirstActivation);
      track.addEventListener('touchstart', onFirstActivation, { passive: true });
      if (prevBtn) prevBtn.addEventListener('focus', onFirstActivation);
      if (nextBtn) nextBtn.addEventListener('focus', onFirstActivation);

      var barsEl    = null;
      var self      = this;
      var bpDesktop = window.matchMedia('(min-width: 768px)');

      function applyBars() {
        var isDesktop = bpDesktop.matches;
        var show  = isDesktop ? dotsDesktop  : dotsMobile;
        var pos   = isDesktop ? dotsDesktopPos : dotsMobilePos;
        var vis   = isDesktop ? dotsDesktopVis : 'always';

        if (!show) {
          if (barsEl) barsEl.style.display = 'none';
          return;
        }

        if (!barsEl) {
          barsEl = document.createElement('div');
          barsEl.style.setProperty('--bars-count', realCount);
          realSlides.forEach(function (_, i) {
            var bar = document.createElement('button');
            bar.type = 'button';
            bar.className = 'product-carousel-bar' + (i === 0 ? ' is-selected' : '');
            bar.setAttribute('aria-label', 'Image ' + (i + 1));
            barsEl.appendChild(bar);
            bars.push(bar);
            bar.addEventListener('click', function () { scrollToIndex(i); });
          });
        }

        barsEl.style.display = '';
        barsEl.className = 'product-carousel-bars product-carousel-bars--' + pos +
          ' product-carousel-bars--' + vis +
          (hasSizeOptions && pos === 'on-image' ? ' product-carousel-bars--size-options' : '');

        if (barsEl.parentNode !== self) {
          self.appendChild(barsEl);
        }
      }

      bpDesktop.addEventListener('change', applyBars);
      applyBars();

      function getRealIndex() {
        var w   = trackWidth() || 1;
        var raw = Math.round(track.scrollLeft / w);
        var idx = enableLoop ? raw - 1 : raw;
        return Math.max(0, Math.min(realCount - 1, idx));
      }

      function scrollToIndex(i) {
        var w   = trackWidth();
        var pos = enableLoop ? (i + 1) * w : i * w;
        track.scrollTo({ left: pos, behavior: 'smooth' });
      }

      function updateUI(index) {
        bars.forEach(function (bar, i) {
          bar.classList.toggle('is-selected', i === index);
        });
        self.dataset.currentIndex = index;
        if (!enableLoop && figure) {
          figure.classList.toggle('at-start', index === 0);
          figure.classList.toggle('at-end',   index === realCount - 1);
        }
      }

      if (!enableLoop && figure) {
        figure.classList.add('at-start');
        if (realCount === 1) figure.classList.add('at-end');
      }

      function onScrollEnd() {
        if (enableLoop) {
          var pos = track.scrollLeft;
          var w   = trackWidth();
          if (!w) return;
          if (pos < 5) {
            jumpTo(realCount * w);
            currentIndex = realCount - 1;
            updateUI(realCount - 1);
            if (activated) preload(realCount - 1);
            return;
          }
          if (pos > (realCount + 1) * w - 5) {
            jumpTo(w);
            currentIndex = 0;
            updateUI(0);
            if (activated) preload(0);
            return;
          }
        }
        var idx = getRealIndex();
        currentIndex = idx;
        updateUI(idx);
        if (activated) preload(idx);
      }

      var scrollEndTimer;
      track.addEventListener('scroll', function () {
        onFirstActivation();
        var idx = getRealIndex();
        if (idx !== currentIndex) {
          currentIndex = idx;
          updateUI(idx);
          if (activated) preload(idx);
        }
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(onScrollEnd, 100);
      }, { passive: true });

      track.addEventListener('scrollend', function () {
        clearTimeout(scrollEndTimer);
        onScrollEnd();
      }, { passive: true });

      function navigatePrev() {
        var w = trackWidth();
        if (!w) return;
        if (enableLoop) {
          track.scrollBy({ left: -w, behavior: 'smooth' });
        } else if (currentIndex > 0) {
          scrollToIndex(currentIndex - 1);
        }
      }

      function navigateNext() {
        var w = trackWidth();
        if (!w) return;
        if (enableLoop) {
          track.scrollBy({ left: w, behavior: 'smooth' });
        } else if (currentIndex < realCount - 1) {
          scrollToIndex(currentIndex + 1);
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', navigatePrev);
        prevBtn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigatePrev(); }
          if (e.key === 'ArrowLeft')               { e.preventDefault(); navigatePrev(); }
          if (e.key === 'ArrowRight')              { e.preventDefault(); navigateNext(); }
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', navigateNext);
        nextBtn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigateNext(); }
          if (e.key === 'ArrowLeft')               { e.preventDefault(); navigatePrev(); }
          if (e.key === 'ArrowRight')              { e.preventDefault(); navigateNext(); }
        });
      }

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () {
          var w = trackWidth();
          if (w) jumpTo(enableLoop ? (currentIndex + 1) * w : currentIndex * w);
        }).observe(track);
      }
    }
  }

  customElements.define('product-card-carousel', ProductCardCarousel);
})();